import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import * as styles from './FreshPromoList.css';
import { INewbuildingPromoV2 } from '../../../types/promosPage';
import { RoundArrowLeft } from '../../RoundArrowLeft';
import { RoundArrowRight } from '../../RoundArrowRight';
import { Section } from '../../Section';
import { Address } from '../Address';
import { FreshPromoCard } from '../FreshPromoCard';
import { Underground } from '../Underground';
import { VerticalSlider } from '../VerticalSlider';

interface IFreshPromoListProps {
  title: string;
  promoList: INewbuildingPromoV2[];
  onCardView(position: number, promo: INewbuildingPromoV2): void;
  onCardClick(position: number, promo: INewbuildingPromoV2): void;
}

export const FreshPromoList: React.FC<IFreshPromoListProps> = ({ title, promoList, onCardView, onCardClick }) => {
  return (
    <Section title={title} data-testid="FreshPromoListSection">
      <div className={styles['container']}>
        <VerticalSlider rightArrow={RoundArrowRight} leftArrow={RoundArrowLeft} itemGap="16px">
          {promoList.map((promoItem, index) => {
            const { image, label, location, logo, newbuildingId, newbuildingName, title } = promoItem;

            const position = index + 1;

            return (
              <ActionAfterViewObserver
                key={newbuildingId}
                triggerOnce={true}
                callback={() => onCardView(position, promoItem)}
              >
                <div className={styles['slide']} data-testid="FreshPromoCardSlide">
                  <FreshPromoCard
                    backgroundImage={image}
                    logoUrl={logo}
                    newbuildingName={newbuildingName}
                    title={title}
                    location={
                      location.metro ? (
                        <Underground underground={location.metro} />
                      ) : (
                        <Address>{location.address}</Address>
                      )
                    }
                    label={label}
                    onClick={() => onCardClick(position, promoItem)}
                  />
                </div>
              </ActionAfterViewObserver>
            );
          })}
        </VerticalSlider>
      </div>
    </Section>
  );
};
